import React from 'react';
import { Button, Grid, Icon } from 'semantic-ui-react';
import { EDIT_ICON, HIDE_ICON, SAVE_ICON, SHOW_ICON } from './HeaderActions.constants';
import './HeaderActions.css';
var defaultProps = {
  showItems: false,
  editItems: true
};
function HeaderActions(_ref) {
  var totalItems = _ref.totalItems,
    onShowItems = _ref.onShowItems,
    showItems = _ref.showItems,
    onEditItems = _ref.onEditItems,
    editItems = _ref.editItems;
  return /*#__PURE__*/React.createElement(Grid, {
    className: "cart-summary-header-actions"
  }, /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Column, {
    width: 8,
    floated: "left",
    className: "header-action-column"
  }, totalItems, " ", totalItems && totalItems > 1 ? 'items' : 'item'), /*#__PURE__*/React.createElement(Grid.Column, {
    width: 8,
    floated: "right",
    textAlign: "right",
    className: "header-action-column"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onEditItems,
    icon: true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: editItems ? SAVE_ICON : EDIT_ICON
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: onShowItems,
    icon: true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: showItems ? HIDE_ICON : SHOW_ICON
  })))));
}
HeaderActions.defaultProps = defaultProps;
export default HeaderActions;